import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var CollapseOutlineSVG = function CollapseOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28.64 14.07l-9.83.1a1.1 1.1 0 01-.79-.35 1 1 0 01-.34-.78l.09-9.86a1.08 1.08 0 011.07-1.07 1 1 0 011.05 1.05l-.08 7.48 8.81-8.84A1 1 0 1130 3.21L21.21 12h7.45a1 1 0 011 1 1.07 1.07 0 01-1.02 1.07zM2.3 19a1 1 0 001 1h7.49L2 28.79a1 1 0 001.38 1.41l8.81-8.84-.08 7.48a1 1 0 001.05 1.05 1.08 1.08 0 001.07-1.07l.09-9.82a1 1 0 00-.34-.78 1.1 1.1 0 00-.79-.35l-9.83.1A1.07 1.07 0 002.3 19z"
  }));
};
CollapseOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CollapseOutlineSVG);